import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Typography } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";

import CloseIcon from "@material-ui/icons/Close";
import PropTypes from 'prop-types';
import information from '../assets/icons/white-information-circle.png';
import CloseButton from "../CustomizedUIs/CloseButton";
const useStyles = makeStyles(theme => ({
  close: {
    padding: theme.spacing(0.5)
  },
  container: {
    marginTop: '5.5em',
  },
  containerInherit: {
    position: 'inherit'
  },
  root:{
    backgroundColor:"#2b3648",
  },
  imgcontainer:{
    width:"15%",
    marginRight: '10px'
  }, 
  imgInherit:{
    width:"10%",
    marginRight: '10px'
  }
  
}));

export default function SnackbarCustom({anchorOrigin, message, open, handleClose, handleUndo, inherit }) {
  const classes = useStyles();

  return (

    <Snackbar
      className={inherit ? classes.containerInherit : classes.container}
      ContentProps={{
        classes: {root:classes.root}
      }}
      anchorOrigin={anchorOrigin}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      message={
        <Box display='flex'>
          <img src={information}  className={inherit ? classes.imgInherit : classes.imgcontainer} />
          <Typography align='center' variant="body2">
            {message}
          </Typography>
        </Box>
      }
      action={
        <React.Fragment>
          <Box display="flex">
            {
              handleUndo &&
              <Button color="secondary" size="small" onClick={handleUndo}>
                UNDO
              </Button>
            }
            <Box bgcolor="#ffffff" width={2} />
            <CloseButton onClick={handleClose}/>
          </Box>
        </React.Fragment>
      }
    />

  );
}

SnackbarCustom.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleUndo: PropTypes.func,
  inherit: PropTypes.bool
};
